export abstract class Exception extends Error {
  readonly status: number;
  readonly statusText: string;
  readonly message: string;
}
